export const IS_LOCKED = 'isLocked';
export const LOCKED_BY_NAME = 'lockedByUserName';
export const LOCKED_BY_CURRENT_USER = 'isLockedByCurrentUser';
export const LOCKED_UNTIL = 'lockedUntil';
